import axios from '@/utils/axios'
import {business, platform, platformUserPrefix, tenantUserPrefix} from '../../common'

/**
 * 获取租户信息
 * @param nameCode
 * @param NotNeedErrorMessage
 */
export const getTenantInfo = (nameCode, NotNeedErrorMessage = false) => {
  return axios({
    url: `${platform}/platform/tenant/tenantInfo`,
    headers: {
      ...(NotNeedErrorMessage ? {NotNeedErrorMessage: true} : {})
    },
    method: 'get',
    params: {nameCode}
  })
}

/**
 * 获取所有租户
 * @param NotNeedErrorMessage
 */
export const getTenantList = (NotNeedErrorMessage = false) => {
  return axios({
    url: `${platform}/platform/tenant/tenantList`,
    headers: {
      ...(NotNeedErrorMessage ? {NotNeedErrorMessage: true} : {})
    },
    method: 'get'
  })
}

/**
 * 平台租户信息列表
 * @param params
 */
export const platformTenantList = () => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/list`,
    method: 'get'
  })
}

/**
 * 平台租户信息列表
 * @param params
 */
export const platformTenantTable = params => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantTable`,
    method: 'post',
    data: params
  })
}

/**
 * 获取租户完整信息
 * @param tenantCode
 */
export const getFullTenantInfo = tenantCode => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/getFullTenantInfo`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 添加平台租户
 * @param form
 */
export const addPlatformTenant = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/addPlatformTenant`,
    method: 'post',
    data: form
  })
}

/**
 * 修改平台租户
 * @param form
 */
export const editPlatformTenant = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/editPlatformTenant`,
    method: 'post',
    data: form
  })
}

/**
 * 删除租户信息
 * @param tenantCodes 租户编号串
 */
export const removePlatformTenant = tenantCodes => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/removePlatformTenant`,
    method: 'delete',
    params: {tenantCodes}
  })
}

// 自动生成AES加解密钥
export const generateAesKey = () =>
  axios.get(`${platform}${platformUserPrefix}/platform/tenant/generateAesKey`)

// 租户获取配置
export const getTenantConfig = () =>
  axios.get(`${business}${tenantUserPrefix}/tenant/config`)



// WEBPACK FOOTER //
// ./src/api/platform/tenant/index.js